import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createApiClient } from '@room/frontend-sdk';
import { AppErrorBoundary, registerDefaultTiles, setAuthAPI } from '@room/shared-ui';
import { App } from './App';
import '@room/shared-ui/styles/tokens.css';
import './styles/tailwind.css';
import '@room/shared-ui/styles/layout-tokens.css';
import '@room/shared-ui/styles/overflow-utilities.css';
// REMOVED: import './styles/pages-fix.css'; - causes body overflow:hidden which hides content
import '@room/shared-ui/styles/general-list.css';

// Register default home tiles to ensure homescreen persistence
registerDefaultTiles();

const api = createApiClient({
  baseURL: '/api',
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

setAuthAPI({
  getSession: () => api.get('/auth/session'),
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>
);
